<template lang="pug">
  .w-full
    .block.fixed.inset-x-0.bottom-0.z-10.bg-gray-100.shadow
      .flex.justify-between
        //- router-link.w-full.justify-center.inline-block.text-center.pt-2.pb-1(to="/")
        //-   i.fas.fa-tachometer-alt
        //-   .tab.tab-home.block.text-xs Dashboard
        router-link.w-full.justify-center.inline-block.text-center.pt-2.pb-1(to="/cirugias")
          i.fas.fa-syringe
          .tab.tab-home.block.text-xs Cirugias
        router-link.w-full.justify-center.inline-block.text-center.pt-2.pb-1(to="/gastos")
          i.fas.fa-hand-holding-usd
          .tab.tab-home.block.text-xs Gastos
        a.w-full.justify-center.inline-block.text-center.pt-2.pb-1(@click="logout")
          i.fas.fa-sign-out-alt
          .tab.tab-home.block.text-xs Cerrar Sesión
</template>

<script>
  export default {
    name: 'bottom-bar',
    data () {
      return {
      }
    },
    methods: {
      logout () {
        if (confirm('¿Desea salir del app?')) {
          localStorage.setItem('token', '')
          localStorage.setItem('perfil', '')
          localStorage.setItem('username', '')
          localStorage.setItem('nombre', '')
          window.location.href = '/'
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
    
</style>



// WEBPACK FOOTER //
// c_menu_bottom.vue?5d03d86e